import { LEADS_TOOLS } from '@workspace/types';

export const LEADS_TOOL_OPTIONS = LEADS_TOOLS.map(name => ({
  name,
  label: name.replace(/_/g, ' '),
}));

/** Con todas tildadas se guarda la lista vacía: el agente recibe también las herramientas nuevas. */
export function leadsToolsToPersist(selected: readonly string[]): string[] {
  const complete = LEADS_TOOL_OPTIONS.every(option => selected.includes(option.name));
  return complete ? [] : [...selected];
}
